import {
    apiRequest,
    laporanPenilaianSKPListDetail,
    // laporanPenilaianSKPActive,
    // laporanPenilaianSKPInactive,
} from "../../../../../services/adapters/kepegawaian/laporanPenilaianSKPService"

class DataTableRepository {

    fetchDetailRowTable = async (query, cancelToken) => {
        return await apiRequest("get", laporanPenilaianSKPListDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    // fetchDetailInactive = async (query) => {
    //     return await apiRequest("post", laporanPenilaianSKPInactive, {
    //         body: query
    //     }, true)
    // }

    // fetchDetailActive = async (query) => {
    //     return await apiRequest("post", laporanPenilaianSKPActive, {
    //         body: query
    //     }, true)
    // }
}

export default DataTableRepository